import { render, staticRenderFns } from "./PromptChangePassword.vue?vue&type=template&id=4d41c8b5&scoped=true&"
import script from "./PromptChangePassword.vue?vue&type=script&lang=js&"
export * from "./PromptChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./PromptChangePassword.vue?vue&type=style&index=0&id=4d41c8b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d41c8b5",
  null
  
)

export default component.exports